module.exports = __webpack_public_path__ + "static/media/youtube.dbb16d4f.svg";